<template>
	<div>
		<b-row>
			<b-col md="6">
				<b-card no-body>
					<b-card-header>
						<div>
							<b-card-title class="mb-25">Magic links (12 mois)</b-card-title>
							<b-card-text class="mb-0">Envoyés vs consommés · <code>TB_CLIENT_MAGICLINK</code></b-card-text>
						</div>
					</b-card-header>
					<b-card-body class="pb-0">
						<vue-apex-charts
							v-if="ready"
							type="line"
							height="240"
							:options="mlChart.chartOptions"
							:series="mlChart.series"
						/>
						<div v-else class="text-center text-muted py-3">
							<b-spinner small variant="primary" /> Chargement…
						</div>
						<div class="mt-1 text-muted small">
							Sur 12 mois : <strong>{{ ml.consumed }}</strong> consommés sur
							<strong>{{ ml.sent }}</strong> envoyés
							(<b-badge variant="light-info">{{ ml.rate }} %</b-badge>)
						</div>
					</b-card-body>
				</b-card>
			</b-col>
			<b-col md="6">
				<b-card no-body>
					<b-card-header>
						<div>
							<b-card-title class="mb-25">Activité par événement (12 mois)</b-card-title>
							<b-card-text class="mb-0">Top 5 events · <code>TB_ESPACECLIENT_ACTIVITY</code></b-card-text>
						</div>
					</b-card-header>
					<b-card-body class="pb-0">
						<vue-apex-charts
							v-if="ready"
							type="line"
							height="240"
							:options="evChart.chartOptions"
							:series="evChart.series"
						/>
						<div v-else class="text-center text-muted py-3">
							<b-spinner small variant="primary" /> Chargement…
						</div>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
		<b-row>
			<b-col cols="12">
				<b-card no-body>
					<b-card-header>
						<div>
							<b-card-title class="mb-25">Top 10 clients les plus actifs (12 mois)</b-card-title>
							<b-card-text class="mb-0">Volume d'événements espace client</b-card-text>
						</div>
					</b-card-header>
					<b-card-body class="pt-0">
						<b-table-simple small striped responsive class="mb-0">
							<b-thead>
								<b-tr>
									<b-th>#</b-th>
									<b-th>Client</b-th>
									<b-th>Email</b-th>
									<b-th class="text-right">Actions</b-th>
								</b-tr>
							</b-thead>
							<b-tbody>
								<b-tr v-for="(c, idx) in topClients" :key="c.ID_client">
									<b-td>{{ idx + 1 }}</b-td>
									<b-td>{{ clientLabel(c) }}</b-td>
									<b-td>{{ c.C_email }}</b-td>
									<b-td class="text-right"><b-badge variant="light-primary">{{ c.nb_actions }}</b-badge></b-td>
								</b-tr>
								<b-tr v-if="!topClients.length"><b-td colspan="4" class="text-center text-muted">Pas d'activité</b-td></b-tr>
							</b-tbody>
						</b-table-simple>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import {
	BRow, BCol, BCard, BCardHeader, BCardTitle, BCardBody, BCardText, BBadge, BSpinner,
	BTableSimple, BThead, BTbody, BTr, BTh, BTd,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'

export default {
	components: {
		BRow,
		BCol,
		BCard,
		BCardHeader,
		BCardTitle,
		BCardBody,
		BCardText,
		BBadge,
		BSpinner,
		BTableSimple,
		BThead,
		BTbody,
		BTr,
		BTh,
		BTd,
		VueApexCharts,
	},
	props: {
		cuis: { type: String, default: '' },
	},
	data() {
		const baseChart = {
			chart: { toolbar: { show: false }, zoom: { enabled: false }, type: 'line' },
			stroke: { curve: 'smooth', width: 3 },
			grid: { borderColor: '#ebe9f1' },
			legend: { show: true, position: 'top' },
			markers: { size: 0, hover: { size: 5 } },
			xaxis: {
				categories: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'],
				axisBorder: { show: false },
			},
			yaxis: { tickAmount: 5 },
			tooltip: { x: { show: false } },
		}
		return {
			ready: false,
			topClients: [],
			ml: { sent: 0, consumed: 0, rate: 0 },
			mlChart: {
				series: [],
				chartOptions: { ...baseChart, colors: ['#7367f0', '#28c76f'] },
			},
			evChart: {
				series: [],
				chartOptions: { ...baseChart, colors: ['#7367f0', '#28c76f', '#ff9f43', '#ea5455', '#00cfe8'] },
			},
		}
	},
	created() { this.load() },
	methods: {
		clientLabel(c) {
			if (c.B_societe && c.C_rs) return c.C_rs
			const nom = `${c.C_prenom || ''} ${c.C_nom || ''}`
			return nom.trim() || c.C_email || `#${c.ID_client}`
		},
		load() {
			const url = `/admin/stats-clients/espace-client${this.cuis ? `?CUIS=${encodeURIComponent(this.cuis)}` : ''}`
			this.$http.get(url)
				.then(response => {
					const d = response.data || {}
					if (d.res === 1) {
						this.mlChart.series = (d.magiclinks && d.magiclinks.series) || []
						this.ml = (d.magiclinks && d.magiclinks.conversion_12m) || { sent: 0, consumed: 0, rate: 0 }
						this.evChart.series = (d.events && d.events.series) || []
						this.topClients = d.top_clients || []
						this.ready = true
					}
				})
				.catch(() => { this.ready = true })
		},
	},
}
</script>
